import css from './setlist.module.scss';
import {Header} from './header/header';
import {Songs} from '../../components/songs/songs';
import {SlideUp} from '../../components/slide-up/slide-up';
import {RootState} from '../../store/store';
import {useDispatch, useSelector} from 'react-redux';
import {ValidateSetlist} from '../../components/validate-setlist/validate-setlist';
import {SubmitSetlist} from '../../components/submit-setlist/submit-setlist';
import {PlayState} from '../../components/play-state/play-state';
import {setAsPlayed, setAsNotPlayed, setSlideUpTitle} from './setlist.slice';
import {Steps} from '../../components/steps/steps';
import {getCurrentSong, getFirstUndefinedPlayState, slideUpTitles, sortSetlistByIndex} from './setlist.helper';

export const Setlist = (): JSX.Element => {
	const dispatch = useDispatch();
	const {title, setlist} = useSelector((state: RootState) => state.setlist);
	const sortedSetlist = sortSetlistByIndex(setlist);
	const firstUndefinedPlayState = getFirstUndefinedPlayState(setlist) as number;

	const onYesClick = () => {
		dispatch(setAsPlayed(firstUndefinedPlayState));
		next(firstUndefinedPlayState);
	};

	const onNoClick = () => {
		dispatch(setAsNotPlayed(firstUndefinedPlayState));
		next(firstUndefinedPlayState);
	};

	const next = (index: number) => {
		const lastIndex = sortedSetlist.at(-1)?.index as number;
		if (index === lastIndex) {
			dispatch(setSlideUpTitle(slideUpTitles.almostDone));
			return;
		}
	};

	const slideUpChild = (title: string) => {
		switch (title) {
			case slideUpTitles.addReorderSetlist:
				return <ValidateSetlist />;
			case slideUpTitles.songPlayed:
				return <PlayState song={getCurrentSong(setlist)} onNoClick={onNoClick} onYesClick={onYesClick} />;
			case slideUpTitles.almostDone:
				return <SubmitSetlist />;
		}
	};

	const setlistIsDraggable = title === slideUpTitles.addReorderSetlist;

	const steps =
		title === slideUpTitles.songPlayed
			? {helper: <Steps current={getCurrentSong(setlist).index} count={setlist.length} />}
			: null;

	return (
		<div className={css.container}>
			<Header />
			<div className={css.title}>Khruangbin Setlist</div>
			<Songs list={setlist} draggable={setlistIsDraggable} />
			<SlideUp {...steps} title={title}>
				{slideUpChild(title)}
			</SlideUp>
		</div>
	);
};
